import { BaseResponse } from '../manager/handle_data/HandleData';
import { PaginationRequest } from '../types';
import apiService from './api.service';
import { FanclubItem } from './fanclub.service';
export interface UserProfileType {
  id: number;
  playerId: number;
  playerName?: string;
  avatar?: string;
  totalPoint?: number;
  fanClub?: FanclubItem;
  joinedAt?: string;
  totalTurnOpenGift?: number;
  lstIncreaseTurnOpenGift?: string;
  lstActivityAt?: string;
  online?: boolean;
  firstLogin?: boolean;
  versionRecord?: number;
  firstOnline?: string;
  lastOnline?: string;
}
class UserProfileService {
  async getAllUsers(params?: PaginationRequest): Promise<BaseResponse<UserProfileType[]>> {
    const res = await apiService.get('/b/players', { params });
    const data = res?.data?.data || [];
    return data;
  }
  async syncDataToRedis(playerId: number): Promise<BaseResponse<any>> {
    const res = await apiService.post(`/b/sync-data-to-redis?playerId=${playerId}`);
    const data = res?.data;
    return data;
  }
  async syncRedisToDB(playerId: number): Promise<BaseResponse<any>> {
    const res = await apiService.post(`/b/sync-data-to-db?playerId=${playerId}`);
    const data = res?.data;
    return data;
  }
}

const userProfileService = new UserProfileService();
export default userProfileService;
